import gql from 'graphql-tag';

export const GET_TAGS = gql`
  query getTags {
    getTags {
      id
      name
      description
    }
  }
`;
